import type { ReactNode } from "react";
import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

const CellContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    width: 100%;

    ${SWReactIcons} svg path {
        fill: ${colorsPalettes.carbon[200]};
    }
`;

type CheckMarkCellProps = {
    value: boolean;
    falseValue?: ReactNode;
};

export const CheckMarkCell = ({ value, falseValue }: CheckMarkCellProps) => {
    return (
        <CellContainer>
            {value ? (
                <SWReactIcons
                    size="xs"
                    iconName="checked"
                />
            ) : (
                falseValue
            )}
        </CellContainer>
    );
};
